/**
 * This File will hold all the enums needs for the projects
 */

export declare enum ButtonDesignation {
   /** A Primary Button is one that carries out the main function of a panel or advances the user forward in the process.
    * There can only be one button with a primary designation per panel section. Multiple primary buttons should never
    * occupy the same row.
    */
   primary = 0,
   /** A Secondary Button is one that modifies content on the current panel without proceeding. There is no limit to the
    * number of secondary buttons that may exist within a panel or row.
    */
   secondary = 1
}

export enum DateRange {
   Today = 0,
   Week = 1,
   Month = 2,
   Last2Days = 3,
   Last3Days = 4,
   Last7Days = 5,
   Last30Days = 6,
   Custom = 7,
   SelectedDay = 8,
   SelectedDayPlusPreviousDay = 9,
   SelectedDayPlusPrevious2Days = 10,
   SelectedDayPlusPrevious3Days = 11,
   SelectedDayPlusPrevious4Days = 12,
   SelectedDayPlusPrevious5Days = 13,
   SelectedDayPlusPrevious6Days = 14,
   SelectedDayPlusPrevious7Days = 15,
   SelectedDayPlusPrevious8Days = 16,
   SelectedDayPlusPrevious9Days = 17,
   SelectedDayPlusPrevious10Days = 18,
   SelectedDayPlusPrevious11Days = 19,
   SelectedDayPlusPrevious12Days = 20,
   SelectedDayPlusPrevious13Days = 21,
   SelectedDayPlus1Day = 22,
   SelectedDayPlus2Days = 23,
   LastWeek = 24,
   LastMonth = 25,
   Last2Weeks = 26,
   Last60Days = 27,
   Last45Days = 28,
   Yesterday = 29,
}

export enum ViewMode {
   LandingPage = 0,
   Appt = 1,
   CustAcct = 2,
   Repair = 3,
   EditAppt = 4,
   ServiceDocs = 5,
   ViewServiceHist = 6,
}

export enum VINEntryFlag {
   Hide = 'H',
   Show = 'S',
   Require = 'R',
}

export enum CustMode {
   Nothing = 0,
   ViewCurrentRepair = 1,
   ViewCurrentAppt = 2,
   AddNewAppt = 3,
   ViewAcctinfo = 4,
   ViewDocs = 5,
   ChangePass = 6,
   ViewVeh = 7,
   CheckRecalls = 8,
   ViewRecSvcs = 9,
   ViewHistory = 10,
   AddVeh = 11,
   ContactDealer = 12,
   CheckMaintContract = 13,
}

export enum Vehicles {
   OEM = 0,
   NAM = 1,
   All = 2,
}